(function () {
  'use strict';

  var cartRequestsPending = 0;
  var cartInteractionPending = false;
  var cartInteractionTimer = null;
  var nativeFetch = window.fetch;

  function cartIsUpdating() {
    return cartRequestsPending > 0 || cartInteractionPending;
  }

  function isCartMutationRequest(input, options) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var method = (options && options.method) || (input && input.method) || 'GET';
    return method.toUpperCase() !== 'GET' && /\/cart\/(add|change|update|clear)(\.js)?(?:[?#]|$)/i.test(url);
  }

  function markCartInteraction() {
    cartInteractionPending = true;
    window.clearTimeout(cartInteractionTimer);
    cartInteractionTimer = window.setTimeout(function () {
      cartInteractionPending = false;
      enforceAll();
    }, 2500);
    enforceCartCheckout();
  }

  function beginCartRequest() {
    cartInteractionPending = false;
    window.clearTimeout(cartInteractionTimer);
    cartRequestsPending += 1;
    enforceCartCheckout();
  }

  function finishCartRequest() {
    cartRequestsPending = Math.max(0, cartRequestsPending - 1);
    window.setTimeout(enforceAll, 150);
  }

  if (typeof nativeFetch === 'function') {
    window.fetch = function (input, options) {
      var cartMutation = isCartMutationRequest(input, options);
      if (cartMutation) beginCartRequest();

      var request;
      try {
        request = nativeFetch.apply(this, arguments);
      } catch (error) {
        if (cartMutation) finishCartRequest();
        throw error;
      }

      if (!cartMutation) return request;
      return request.then(function (response) {
        finishCartRequest();
        return response;
      }, function (error) {
        finishCartRequest();
        throw error;
      });
    };
  }

  function numberValue(value) {
    var parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  function getState(form) {
    var box = form && form.querySelector('.product-checkout-buttons');
    if (!box) return null;

    var requiredEach = numberValue(box.dataset.trovePointsRequired);
    if (requiredEach <= 0) return null;

    var quantityInput = form.querySelector('[name="quantity"]');
    var quantity = Math.max(1, Math.floor(numberValue(quantityInput && quantityInput.value) || 1));
    var earned = numberValue(box.dataset.troveCartPointsEarned);
    var alreadyRequired = numberValue(box.dataset.troveCartPointsRequired);
    var available = Math.max(0, earned - alreadyRequired);
    var needed = requiredEach * quantity;

    return {
      box: box,
      button: form.querySelector('[data-add-to-cart]'),
      requiredEach: requiredEach,
      quantity: quantity,
      available: available,
      needed: needed,
      blocked: needed > available
    };
  }

  function showError(form, state) {
    var message = form.querySelector('[data-add-cart-error]');
    var copy = 'This quantity requires ' + state.needed + ' promotional ' +
      (state.needed === 1 ? 'point' : 'points') + '. Your cart currently has ' +
      state.available + ' available. Add qualifying point-earning products first.';

    if (message) {
      message.textContent = copy + ' ';
      var link = document.createElement('a');
      link.href = '/collections/points-earned';
      link.textContent = 'Shop products that earn points';
      message.appendChild(link);
      message.classList.remove('hidden');
      message.focus();
    }
  }

  function enforce(form) {
    var state = getState(form);
    if (!state || !state.button) return state;

    if (state.blocked) {
      state.button.disabled = true;
      state.button.setAttribute('data-trove-points-locked', 'true');
      state.button.setAttribute(
        'title',
        'Requires ' + state.needed + ' promotional points; ' + state.available + ' are currently available.'
      );
    }
    return state;
  }

  function enforceAll() {
    document.querySelectorAll('form[data-type="add-to-cart-form"]').forEach(enforce);
    enforceCartCheckout();
  }

  function cartState() {
    var states = document.querySelectorAll('[data-trove-cart-state]');
    if (!states.length) return null;

    var state = states[states.length - 1];
    var earned = numberValue(state.dataset.troveCartPointsEarned);
    var required = numberValue(state.dataset.troveCartPointsRequired);

    return {
      earned: earned,
      required: required,
      missing: Math.max(0, required - earned),
      blocked: required > earned
    };
  }

  function cartErrorMessage(state) {
    return 'This cart earns ' + state.earned + ' promotional ' +
      (state.earned === 1 ? 'point' : 'points') + ', but requires ' +
      state.required + '. Add qualifying products or remove restricted items. ';
  }

  function ensureCartError(state) {
    var container = document.querySelector('[data-trove-cart-state]');
    if (!container || !container.parentNode) return;

    var message = container.parentNode.querySelector('[data-trove-cart-error]');
    var updating = cartIsUpdating();
    if (!state.blocked && !updating) {
      if (message) message.remove();
      return;
    }

    if (!message) {
      message = document.createElement('p');
      message.setAttribute('data-trove-cart-error', '');
      message.setAttribute('role', 'alert');
      message.style.color = '#b42318';
      message.style.fontWeight = '700';
      message.style.margin = '0 0 12px';
      container.insertAdjacentElement('afterend', message);
    }

    if (updating) {
      if (message.dataset.troveMessageMode === 'updating') return;
      message.dataset.troveMessageMode = 'updating';
      message.textContent = 'Updating your cart… Please wait before checking out.';
      return;
    }

    var stateKey = state.earned + ':' + state.required;
    if (message.dataset.troveMessageMode === 'blocked' && message.dataset.troveStateKey === stateKey) return;
    message.dataset.troveMessageMode = 'blocked';
    message.dataset.troveStateKey = stateKey;
    message.textContent = cartErrorMessage(state);
    var link = document.createElement('a');
    link.href = '/collections/points-earned';
    link.textContent = 'Shop products that earn points';
    message.appendChild(link);
  }

  function enforceCartCheckout() {
    var state = cartState();
    var updating = cartIsUpdating();
    if (!state && !updating) return;

    if (state) ensureCartError(state);
    document.querySelectorAll('[name="checkout"], [href^="/checkout"]').forEach(function (control) {
      if (updating || (state && state.blocked)) {
        control.setAttribute('aria-disabled', 'true');
        control.setAttribute('data-trove-checkout-locked', 'true');
        if ('disabled' in control) control.disabled = true;
      } else if (control.hasAttribute('data-trove-checkout-locked')) {
        control.removeAttribute('aria-disabled');
        control.removeAttribute('data-trove-checkout-locked');
        if ('disabled' in control) control.disabled = false;
      }
    });

    document.querySelectorAll('.additional-checkout-buttons, .cart__dynamic-checkout-buttons').forEach(function (box) {
      box.hidden = updating || Boolean(state && state.blocked);
    });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest && event.target.closest('form[data-type="add-to-cart-form"]');
    if (!form) {
      var cartForm = event.target.closest && event.target.closest('form[action*="/cart"]');
      var checkoutSubmit = event.submitter && (
        event.submitter.name === 'checkout' ||
        (event.submitter.getAttribute && /^\/checkout/.test(event.submitter.getAttribute('href') || ''))
      );
      if (!cartForm || !checkoutSubmit) return;

      var currentCartState = cartState();
      if (cartIsUpdating() || (currentCartState && currentCartState.blocked)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (currentCartState) ensureCartError(currentCartState);
      }
      return;
    }

    var state = getState(form);
    if (state && state.blocked) {
      event.preventDefault();
      event.stopImmediatePropagation();
      showError(form, state);
    }
  }, true);

  document.addEventListener('click', function (event) {
    var cartControl = event.target.closest && event.target.closest(
      'cart-remove-button, .cart-product-remove, .quantity-button, [data-cart-remove]'
    );
    if (cartControl) markCartInteraction();

    var checkout = event.target.closest && event.target.closest('[name="checkout"], [href^="/checkout"]');
    var currentCartState = cartState();
    if (checkout && (cartIsUpdating() || (currentCartState && currentCartState.blocked))) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (currentCartState) ensureCartError(currentCartState);
      return;
    }

    var button = event.target.closest && event.target.closest('[data-add-to-cart]');
    if (!button) return;
    var form = button.closest('form[data-type="add-to-cart-form"]');
    if (!form) return;

    var state = getState(form);
    if (state && state.blocked) {
      event.preventDefault();
      event.stopImmediatePropagation();
      showError(form, state);
    }
  }, true);

  document.addEventListener('change', function (event) {
    if (!event.target.matches('[name="quantity"], .ajax-quantity')) return;
    if (event.target.closest('cart-items, cart-drawer-items')) markCartInteraction();
    var form = event.target.closest('form[data-type="add-to-cart-form"]');
    if (form) enforce(form);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enforceAll);
  } else {
    enforceAll();
  }

  new MutationObserver(enforceAll).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
